import { render, staticRenderFns } from "./offer-group.vue?vue&type=template&id=46d15249"
import script from "./offer-group.vue?vue&type=script&lang=js"
export * from "./offer-group.vue?vue&type=script&lang=js"
import style0 from "./offer-group.vue?vue&type=style&index=0&id=46d15249&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports